module.exports = __webpack_public_path__ + "static/media/logo.d9f97659.svg";